import { render, staticRenderFns } from "./CreateCourseCategoryPopup.vue?vue&type=template&id=6096978e"
import script from "./CreateCourseCategoryPopup.vue?vue&type=script&lang=js"
export * from "./CreateCourseCategoryPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports